<template>
  <div>
    <div class="handle-box">
      <el-input
        size="small"
        placeholder="输入名称"
        v-model.trim="searchName"
        class="handle-input mr10"
      ></el-input>
      <el-select
        class="mr10 search-item"
        v-model="manageOpen"
        placeholder="请选择"
        size="small"
      >
        <el-option
          v-for="item in manageOpenOption"
          :key="item.value"
          :label="item.label"
          :value="item.value"
        >
        </el-option>
      </el-select>
      <el-button
        type="primary"
        icon="el-icon-search"
        @click="getData(1)"
        size="small"
        >搜索</el-button
      >
    </div>
    <el-table
      :data="data.records"
      border
      class="table"
      ref="multipleTable"
      header-cell-class-name="table-header"
    >
      <el-table-column width="180px" align="center" label="专题封面">
        <template #default="scope">
          <el-image
            fit="cover"
            class="cover"
            v-if="scope.row.cover"
            :src="$utils.fileUrl(scope.row.cover)"
            :preview-src-list="[`${$utils.fileUrl(scope.row.cover)}`]"
          >
          </el-image>
        </template>
      </el-table-column>
      <el-table-column
        prop="name"
        align="center"
        label="专题名称"
      ></el-table-column>
      <el-table-column align="center" prop="topicName" label="包含课程">
        <template #default="scope">
          课程数量：{{ scope.row.topicCount }}
        </template>
      </el-table-column>
      <el-table-column prop="companyName" label="发布者" align="center">
      </el-table-column>
      <el-table-column label="发布时间" align="center">
        <template #default="scope"
          >{{ $utils.formatDate(scope.row.createTime, "yyyy-MM-dd hh:mm:ss") }}
        </template>
      </el-table-column>
      <el-table-column label="上架状态" align="center">
        <template #default="scope"
          >{{ scope.row.isOpen === 0 ? "下架" : "上架" }}
        </template>
      </el-table-column>
      <el-table-column label="查看详情" align="center">
        <template #default="scope">
          <el-button size="small" type="text" @click="info(scope.row)"
            >查看详情</el-button
          >
        </template>
      </el-table-column>
      <!-- <el-table-column label="链接地址" align="center">
        <template #default="scope">
          <el-button size="small" type="primary" @click="player(scope.row)"
            >播放视频</el-button
          >
        </template>
      </el-table-column> -->
      <el-table-column label="操作" width="180" align="center">
        <template #default="scope">
          <el-button
            type="primary"
            size="mini"
            v-if="scope.row.manageOpen === 0"
            @click="handleEdit(scope.row.id, 1)"
            >恢复展示</el-button
          >
          <el-button
            type="danger"
            size="mini"
            v-if="scope.row.manageOpen === 1"
            @click="handleEdit(scope.row.id, 0)"
            >禁止展示</el-button
          >
          <el-button type="danger" size="mini" @click="delData(scope.row.id)"
            >删除</el-button
          >
        </template>
      </el-table-column>
    </el-table>
    <div class="pagination">
      <el-pagination
        background
        layout="total, prev, pager, next"
        :current-page="data.current"
        :page-size="20"
        :total="data.total"
        @current-change="getData"
      ></el-pagination>
    </div>
    <!-- 详情 -->
    <el-dialog
      title="课程详情"
      v-model="infoDialog"
      width="900px"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
    >
      <div class="video-info">
        <div class="cover-title">
          <div
            class="cover"
            :style="`background-image:url(${$utils.fileUrl(itemData.cover)})`"
          ></div>
          <div>
            <h2>{{ itemData.name }}</h2>
            <li>{{ itemData.companyName }}</li>
          </div>
        </div>
        <li>
          <span>{{
            $utils.formatDate(itemData.createTime, "yyyy-MM-dd hh:mm:ss")
          }}</span>
        </li>
        <el-table
          border
          class="table"
          ref="multipleTable"
          :data="listData.records"
          header-cell-class-name="table-header"
        >
          <el-table-column prop="name" label="课程名字"> </el-table-column>
          <el-table-column label="公开类型" align="center" width="100px">
            <template #default="scope">
              <el-button size="small" type="text" v-if="scope.row.type === 1"
                >公开课</el-button
              >
              <el-button size="small" type="text" v-if="scope.row.type === 2"
                >私教课</el-button
              >
            </template>
          </el-table-column>
        </el-table>

        <div class="pagination">
          <el-pagination
            background
            layout="total, prev, pager, next"
            :current-page="listData.current"
            :page-size="10"
            :total="listData.total"
            @current-change="getPage"
          ></el-pagination>
        </div>
      </div>
      <template #footer>
        <span class="dialog-footer">
          <el-button type="primary" @click="infoDialog = false">关闭</el-button>
        </span>
      </template>
    </el-dialog>
  </div>
</template>

<script>
export default {
  data() {
    return {
      data: {},
      type: "",
      searchName: "",
      infoDialog: false,
      manageOpen: null,
      manageOpenOption: [
        { label: "全部", value: 2 },
        { label: "正常展示", value: 1 },
        { label: "被禁止展示", value: 0 },
      ],
      itemData: {},
      listData: {},
      loading: false,
    };
  },
  methods: {
    async getData(page) {
      const params = {
        searchName: this.searchName,
        type: this.type,
        status: this.status,
        currentPage: page,
        pageSize: 20,
        manageOpen: this.manageOpen,
      };
      this.$loading.start();
      const res = await this.$api.train.special.getData(params);
      this.$loading.done();
      if (res.code === 10200) {
        this.data = res.data;
      } else {
        this.$message.error(res.msg);
      }
    },
    handleEdit(id, status) {
      if (!this.loading) {
        const text = status === 0 ? "是否确认禁止展示？" : "是否确认恢复？";
        this.$confirm(text, "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        })
          .then(async () => {
            this.loading = true;
            this.$loading.start();
            const params = {
              id: id,
              manageOpen: status,
            };
            const res = await this.$api.train.special.setData(params);
            this.loading = false;
            this.$loading.done();
            if (res.code === 10200) {
              this.getData(this.data.current);
              this.$message.success("操作成功！");
            } else {
              this.$message.error(res.msg);
            }
          })
          .catch(() => {});
      }
    },
    delData(id) {
      if (!this.loading) {
        this.$confirm("是否确认删除？", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        })
          .then(async () => {
            this.loading = true;
            this.$loading.start();
            const params = {
              id: id,
            };
            const res = await this.$api.train.special.delData(params);
            this.loading = false;
            this.$loading.done();
            if (res.code === 10200) {
              this.getData(this.data.current);
              this.$message.success("删除成功！");
            } else {
              this.$message.error(res.msg);
            }
          })
          .catch(() => {});
      }
    },
    player(data) {
      if (data.video === null) {
        this.$message.warning("视频还在转码中请稍后再试");
      } else {
        this.itemData = data;
        this.dialogVisible = true;
      }
    },
    async info(data) {
      if (!this.loading) {
        try {
          this.loading = true;
          this.$loading.start();
          const res = await this.$api.train.special.getInfo(data.id);
          this.loading = false;
          this.$loading.done();
          if (res.code === 10200) {
            this.itemData = res.data.sysTrainingTopic;
            this.listData = res.data.topicLessonList;
            this.infoDialog = true;
          } else {
            this.$message.error(res.msg);
          }
        } catch (error) {
          this.loading = false;
          this.$loading.done();
        }
      }
    },
    async getPage(page) {
      if (!this.loading) {
        try {
          this.loading = true;
          this.$loading.start();
          const params = {
            currentPage: page,
            pageSize: 10,
          };
          const res = await this.$api.train.special.getInfoPage(
            this.itemData.id,
            params
          );
          this.loading = false;
          this.$loading.done();
          if (res.code === 10200) {
            this.listData = res.data;
          } else {
            this.$message.error(res.msg);
          }
        } catch (error) {
          this.loading = false;
          this.$loading.done();
        }
      }
    },
  },
  created() {
    this.getData();
  },
  
};
</script>

<style lang="scss" scoped>
.handle-input {
  width: 200px;
  display: inline-block;
}

.search-item {
  width: 140px;
}

.handle-box {
  margin-bottom: 20px;
}

.cover {
  width: 150px;
  height: 200px;
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
}

.video {
  height: 500px;
}

.video-info {
  .cover-title {
    display: flex;
    align-items: center;

    .cover {
      width: 120px;
      margin-right: 24px;
    }

    h2 {
      font-weight: 500;
      margin-bottom: 15px;
      font-size: 1rem;
    }
  }

  & > li {
    display: flex;
    margin-bottom: 24px;
    line-height: 30px;
  }
}
</style>